import Features from './Features';

const FeatureDefaults = {
  [Features.EmailRecipientMax]: 20
};

export default FeatureDefaults;
